import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { McpConnectionProperties, McpServerType } from '@server/mcp';
import type { RootState } from '.';

interface McpConnectionsState {
  connections: McpConnectionProperties[] | undefined;
  isLoading: boolean;
}

const initialState: McpConnectionsState = {
  connections: undefined,
  isLoading: false,
};

export const mcpConnectionsSlice = createSlice({
  name: 'mcpConnections',
  initialState,
  reducers: {
    setConnections: (state, action: PayloadAction<McpConnectionProperties[]>) => {
      state.connections = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    addConnection: (state, action: PayloadAction<McpConnectionProperties>) => {
      state.connections = [...(state.connections ?? []), action.payload];
    },
    removeConnection: (state, action: PayloadAction<string>) => {
      state.connections = state.connections?.filter((c) => c.id !== action.payload);
    },
  },
});

export const { setConnections, setIsLoading, addConnection, removeConnection } =
  mcpConnectionsSlice.actions;

export const selectMcpConnections = (state: RootState) => state.mcpConnections.connections;
export const selectMcpConnectionsIsLoading = (state: RootState) => state.mcpConnections.isLoading;
export const selectMcpConnectionByServerType =
  (serverType: McpServerType) => (state: RootState) =>
    state.mcpConnections.connections?.find((c) => c.serverType === serverType);

export default mcpConnectionsSlice.reducer;
